define("shared/utils/segment/system-labels", ["exports", "@ember/debug", "@ember/utils", "lodash", "later/utils/object-promise-proxy"], function (_exports, _debug, _utils, _lodash, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.systemLabelsFromPostMediaItems = _exports.systemLabelsFromGram = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/utils",0,"lodash",0,"later/utils/object-promise-proxy"eaimeta@70e063a35619d71f
  /**
   * Grabs all of the system labels from a gram and converts it to a readable_format for segment.
   */
  const systemLabelsFromGram = async gram => {
    const labels = await Promise.all(gram.get('postMediaItems').map(async pmi => {
      const mediaItem = await pmi.mediaItem;
      const systemLabels = await _getSystemLabelsFromMediaItem(mediaItem);
      return (0, _utils.isEmpty)(systemLabels) ? 'null_value' : systemLabels;
    }));
    return _format(labels);
  };
  _exports.systemLabelsFromGram = systemLabelsFromGram;
  const systemLabelsFromPostMediaItems = async postMediaItems => {
    if ('ordering' in postMediaItems && postMediaItems.ordering === 0) {
      const firsPostMediaItem = postMediaItems.firstObject;
      const firstMediaItem = await firsPostMediaItem?.get('mediaItem');
      const systemLabels = await _getSystemLabelsFromMediaItem(firstMediaItem);
      return (0, _utils.isEmpty)(systemLabels) ? 'null_value' : _format(systemLabels);
    }
    const labels = await Promise.all(postMediaItems.map(async pmi => {
      const mediaItem = await pmi.mediaItem;
      const systemLabels = await _getSystemLabelsFromMediaItem(mediaItem);
      return (0, _utils.isEmpty)(systemLabels) ? 'null_value' : systemLabels;
    }));
    return _format(labels);
  };
  _exports.systemLabelsFromPostMediaItems = systemLabelsFromPostMediaItems;
  const _format = labels => {
    if (!labels) {
      return '';
    }
    if ((0, _lodash.isString)(labels)) {
      return labels.replace(/ /g, '_');
    }
    return labels.flat().join(',').replace(/ /g, '_');
  };
  const _getSystemLabelsFromMediaItem = async mediaItem => {
    (false && !(mediaItem) && (0, _debug.assert)('_getSystemLabelsFromMediaItem requires a media item', mediaItem));
    const resolvedMediaItem = await (0, _objectPromiseProxy.default)(mediaItem);
    const systemLabels = resolvedMediaItem?.labels.filter(label => label.isSystemLabel).map(label => label.canonicalTagName);
    return _format(systemLabels);
  };
});